import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuthContext } from '../context/AuthContext';

export default function Layout({ children }) {
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="app-shell">
      <Sidebar user={user} />
      <div className="app-main">
        <header className="topbar">
          <div>
            <h1 className="page-title">Content administration</h1>
            <div className="muted">Manage content, media, users, and publishing from one console.</div>
          </div>
          <button className="button secondary" onClick={handleLogout}>
            Sign out
          </button>
        </header>
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
}
